import {useContext} from "react";
import {LoadingContext} from "./LoadingContextProvider";

const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context)
        throw new Error("Loading Context should be used within LoadingContextProvider")

    return context;
}

export default useLoading;
